import { Box, Typography, Stack, Radio } from '@mui/material';
import { useFormikContext } from 'formik';
import CardBrandIcon from 'renderer/shared/payments/CardBrandIcon';

interface ExistingPaymentMethodsForm {
  isNewPaymentMethod: boolean;
  existingPaymentMethodToken: string;
}

interface Props {
  paymentMethods: {
    _id: string;
    cardType: string;
    last4: string;
    expMonth?: string;
    expYear?: string;
  }[];
}

const ExistingPaymentMethods = ({ paymentMethods }: Props) => {
  const { values, setFieldValue } =
    useFormikContext<ExistingPaymentMethodsForm>();

  const handleSelect = (id: string) => {
    setFieldValue('existingPaymentMethodToken', id);
    setFieldValue('isNewPaymentMethod', false);
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Stack spacing={2}>
        {paymentMethods.map((card) => (
          <Box
            key={card._id}
            sx={{
              border:
                values.existingPaymentMethodToken === card._id
                  ? '2px solid #2e7d32'
                  : '1px solid #e0e0e0',
              borderRadius: 2,
              // p: 2,
              p: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              cursor: 'pointer',
            }}
            onClick={() => handleSelect(card._id)}
          >
            <Stack direction="row" spacing={2} alignItems="center">
              <Radio
                checked={values.existingPaymentMethodToken === card._id}
                onChange={() => handleSelect(card._id)}
                value={card._id}
                sx={{
                  color: '#2e7d32',
                  '&.Mui-checked': { color: '#2e7d32' },
                }}
              />

              <CardBrandIcon cardType={card.cardType} />

              <Box>
                <Typography variant="body1" fontWeight="bold">
                  {card.cardType} ending in {card.last4}
                </Typography>
                {card.expMonth && card.expYear && (
                  <Typography variant="body2" color="text.secondary">
                    Expires {card.expMonth}/{card.expYear}
                  </Typography>
                )}
              </Box>
            </Stack>
          </Box>
        ))}
      </Stack>

      <Box mt={2}>
        <Typography
          variant="body2"
          color="primary"
          sx={{ cursor: 'pointer', fontWeight: 'bold' }}
          onClick={() => setFieldValue('isNewPaymentMethod', true)}
        >
          ➕ Add a new card
        </Typography>
      </Box>
    </Box>
  );
};

export default ExistingPaymentMethods;
